<template lang="pug">
.row
  .col-lg-6
    .d-flex.mb-1
      small.green {{ $t('Buy') }} {{ quote_token.symbol.name }}
      span(
        @click="setAmount('buy')"
        class="text-mutted small align-self-end ml-auto cursor-pointer"
      ) {{ baseBalance | commaFloat(base_token.symbol.precision) }}
        i.el-icon-wallet.ml-1

    el-form
      el-form-item
        el-input(
          type="number"
          inputmode="decimal"
          :placeholder="$t('Buy at best price')"
          size="medium"
          disabled
        )
          span(slot="suffix").mr-1 {{ base_token.symbol.name }}

      el-form-item
        el-input(
          type="number"
          inputmode="decimal"
          v-model="totalBuy"
          size="medium"
          placeholder="0"
          clearable
        )
          span(slot="prefix").mr-1 {{ $t('AMOUNT') }}
          span(slot="suffix").mr-1 {{ base_token.symbol.name }}

      .px-3
        el-slider(
          :step="1"
          v-model="percentBuy2"
          :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }"
          :show-tooltip="false"
        ).slider-buy

      el-form-item.mt-5
        el-button(
          class="w-100"
          type="success"
          size="small"
          @click="actionOrder('market', 'buy')"
        ) {{ $t('Buy') }} {{ quote_token.str }}

  .col-lg-6
    .d-flex.mb-1
      small.red {{ $t('Sell') }} {{ quote_token.symbol.name }}
      span(
        class="text-mutted small align-self-end ml-auto cursor-pointer"
        @click="setAmount('sell')"
      ) {{ tokenBalance | commaFloat(quote_token.symbol.precision) }}
        i.el-icon-wallet.ml-1

    el-form
      el-form-item
        el-input(
          type="number"
          :placeholder="$t('Sell at best price')"
          size="medium"
          disabled
        )
          span(slot="suffix").mr-1.ml-2 {{ base_token.symbol.name }}

      el-form-item
        el-input(
          type="number"
          v-model="amountSell"
          size="medium"
          placeholder="0"
          clearable
        )
          span(slot="prefix").mr-1 {{ $t('AMOUNT') }}
          span(slot="suffix").mr-1 {{ quote_token.symbol.name }}

      .px-3
        el-slider(
          :step="1"
          v-model="percentSell"
          :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }"
          :show-tooltip="false"
        ).slider-sell

      el-form-item.mt-5
        el-button(
          class="w-100"
          type="danger"
          size="small"
          @click="actionOrder('market', 'sell')"
        ) {{ $t('Sell') }} {{ quote_token.str }}
</template>

<script>
// TODO Короче еще сделать для маркеттрейда размер в EOS сумировать по ордерам
import { trade } from '~/mixins/trade'

export default {
  mixins: [trade],

  data() {
    return {
      percentBuyLocal: 0
    }
  },

  computed: {
    percentBuy2: {
      get() { return this.percentBuyLocal },
      set(val) {
        this.percentBuyLocal = val

        if (val == 100) {
          this.$store.commit('market/SET_TOTAL_BUY', parseFloat(this.baseBalance))
        } else {
          this.changePercentBuy({ percent: val })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.green {
  color: var(--color-primary)
}

.red {
  color: var(--main-red)
}
</style>
